import { render, staticRenderFns } from "./LoadingSpinnerTable.vue?vue&type=template&id=56e20a08"
import script from "./LoadingSpinnerTable.vue?vue&type=script&lang=js"
export * from "./LoadingSpinnerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports